import EfficeTitle from "components/Home/ui/EfficeTitle";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { selectCurrentUserAttributes } from "slices/authSlice";
import MyIcon from "./MyIcon";
import ExtraOptionsModal from "./ExtraOptionsModal";
import HelperTip from "components/HOCS/HelperTip";
import { FM_PERSONALSETTINGS } from "helpers/freshman";
import HlpPersonalSettings from "components/HelpSlides/HlpPersonalSettings";
import EfsTippy from "components/HOCS/EfsTippy";
import Modal from "components/HOCS/Modal";
import HelpModalBody from "components/Home/Modals/GetHelp/HelpModalBody/HelpModalBody";
import HelpIcon from "graphics/icons/HelpIcon";
import { getPersonName } from "helpers/randomHelpers";

const ExtraOptionsAvatar = ({ currentActiveAlive }) => {
  const currentuserAttributes = useSelector(selectCurrentUserAttributes);
  const [modalOpen, setModalOpen] = useState(false);
  const [helpModal, setHelpModal] = useState(false);
  const close = () => setHelpModal(false);

  return (
    <div className="head-list-extras">
      {modalOpen ? (
        <ExtraOptionsModal
          onDismiss={() => {
            setModalOpen(false);
          }}
        ></ExtraOptionsModal>
      ) : null}

      <EfsTippy
        placement="right"
        className="root-Tippy"
        disabled={!currentActiveAlive}
        content={"Help"}
      >
        <div
          className="head-effice-item"
          onClick={() => {
            setHelpModal(true);
          }}
        >
          <HelpIcon />
          {helpModal && (
            <Modal
              growth={false}
              noBackDropClick={false}
              lightBackDrop={true}
              header={`Help`}
              content={<HelpModalBody onDismiss={close} />}
              onDismiss={close}
            />
          )}
          <div className="head-effice-title">
            <EfficeTitle root={true} title="Help" ntfy={"ACTIVE"} />
          </div>
        </div>
      </EfsTippy>
      <EfsTippy
        placement="right"
        className="root-Tippy"
        disabled={!currentActiveAlive}
        content={"Account"}
      >
        <div
          className="head-effice-item"
          onClick={() => {
            setModalOpen(true);
          }}
        >
          <HelperTip
            code={FM_PERSONALSETTINGS}
            placement="top"
            component={<HlpPersonalSettings />}
            offset={[0, 30]}
            arrowWhite
          >
            <div className="effice-icon-mr-side">
              <MyIcon myAttr={currentuserAttributes} />
            </div>
          </HelperTip>
          <div className="head-effice-title">
            <EfficeTitle
              id={false}
              root={true}
              title={getPersonName(
                currentuserAttributes?.given_name,
                currentuserAttributes?.family_name
              )}
              ntfy={"ACTIVE"}
            />
          </div>
        </div>
      </EfsTippy>
    </div>
  );
};

export default ExtraOptionsAvatar;
